import {Role} from "../components/shared/permissions";

export interface LoginCredentials {
  email: string,
  password: string,
}

export interface PasswordRecovery {
  resetToken: string;
  password: string;
}

export interface AdminSignupPayload {
  firstName: string;
  lastName: string;
  password: string;
  invitationToken: string;
}

export interface InvitationPayload {
  name: string;
  email: string;
  role: string;
}

export class AdminUser {
  id: number;
  email: string;
  name: string;
  role: Role;
  state?: string;
  password?: string;
  token?: string;
  createdAt?: Date;

  constructor(params: Partial<AdminUser>) {
    Object.assign(this, params);
  }
}
